"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _antd = require("antd");

var _axios = _interopRequireDefault(require("axios"));

var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));

var _auth = require("../../utils/auth"); // import app components


var graphql = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(query, source) {
    var cancelTokenSource, cleanedUrl, headers, user, result, _err$response, _err$response$data;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            // Create a new CancelToken source for this request
            cancelTokenSource = _axios.default.CancelToken.source(); // TODO: Move to utils function

            cleanedUrl = source.replace(/\/+$/, '');
            headers = {};
            user = (0, _auth.getUser)();

            if (user !== null && user !== void 0 && user.authToken) {
              headers.Authorization = "Bearer ".concat(user.authToken);
            }

            _context.next = 8;
            return _axios.default.post("".concat(cleanedUrl, "/graphql"), {
              query: query
            }, {
              headers: headers
            });

          case 8:
            result = _context.sent;
            // Cancel request
            cancelTokenSource.cancel();

            if (!(result !== null && result !== void 0 && result.data)) {
              _context.next = 12;
              break;
            }

            return _context.abrupt("return", result.data);

          case 12:
            _context.next = 17;
            break;

          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](0);

            if (_context.t0 !== null && _context.t0 !== void 0 && (_err$response = _context.t0.response) !== null && _err$response !== void 0 && (_err$response$data = _err$response.data) !== null && _err$response$data !== void 0 && _err$response$data.message) {
              _antd.message.error((0, _htmlReactParser.default)(_context.t0.response.data.message));
            }

          case 17:
            return _context.abrupt("return", null);

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 14]]);
  }));

  return function graphql(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var _default = graphql;
exports.default = _default;